<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container" *ngIf="notificationService.notifications.length > 0">
  <div class="header-title mb-2">
    <h2>{{"NOTIFICATIONS.TITLE" | translate}}</h2>
    <button class="its-button" (click)="archiveMultipleNotifications()">
      <span *ngIf="!notificationService.notificationSpinner">
        {{"NOTIFICATIONS.ARCHIVE-BTN" | translate}}
      </span>
      <ion-spinner name="circular" *ngIf="notificationService.notificationSpinner"  style="height: 14px;"></ion-spinner>
    </button>
  </div>
  <div style="padding: 15px;">
    <div class="custom-radio" (click)="selectAllNotification()">
      <div class="inner-radio" *ngIf="allSelected"></div>
    </div>
  </div>
  <div class="notification info-box" *ngFor="let notification of notificationService.notifications">
    <span class="left-part">
     <div class="custom-radio" (click)="selectNotification(notification.notificationId)">
      <div class="inner-radio" *ngIf="selectedNotifications.includes(notification.notificationId)"></div>
    </div>
    <div (click)="(!notificationService.notificationSpinner || notificationService.notificationSpinner && !selectedNotifications.includes(notification.notificationId)) ? openNotification(notification) : null">
      <p class="notification-name">{{notification.notification.i18nTitle ? notification.notification.i18nTitle[translate.currentLang.toUpperCase()] : notification.notification.i18nSubject[translate.currentLang.toUpperCase()]}}</p>
      <p class="notification-date">{{getTime(notification.notification.notificationDate)}}</p>
    </div>
    </span>
    <mat-icon svgIcon="mat:arrow_forward_ios" *ngIf="!notificationService.notificationSpinner || notificationService.notificationSpinner && !selectedNotifications.includes(notification.notificationId)" (click)="openNotification(notification)"></mat-icon>
    <ion-spinner name="circular" *ngIf="notificationService.notificationSpinner && selectedNotifications.includes(notification.notificationId)"  style="height: 14px;"></ion-spinner>
  </div>
</div>
<div class="container" *ngIf="notificationService.notifications.length === 0">
  <h2>{{"NOTIFICATIONS.TITLE" | translate}}</h2>
  <p class="no-content">{{"NOTIFICATIONS.NO-CONTENT" | translate}}</p>
</div>
